import { USER_MENU_ICON_SIZE } from '@hivewatch/dark'

import { BUTTON_PRESS } from '@/utils/analytics'

/**
 * Geometry for the side nav account row, from Figma node 991:2032.
 *
 * Note the 8px radius: unlike the User Menu — which is sharp on all four
 * corners — the account row keeps a radius in the new design, down from the
 * 16px it had before. Avatar sizing comes from `UserAvatar`'s own scale.
 * Everything the menu surface needs (width, padding, z-index) is owned by
 * `UserMenu` in `@hivewatch/dark`.
 */
export const PROFILE_CARD_STYLES = {
  OFFSET: '16px',
  BORDER_RADIUS: '8px',
  PADDING_EXPANDED: '12px 16px',
  PADDING_COLLAPSED: '10px 16px',
  MARGIN: '0 8px 10px 8px',
  MIN_HEIGHT_EXPANDED: '58px',
  MIN_HEIGHT_COLLAPSED: '42px',
  AVATAR_TEXT_GAP: '12px',
  TEXT_BLOCK_GAP: '4px',
  TRANSITION: 'all 0.3s ease-in-out',
} as const

/** Leading icon size for the sidebar's UserMenu rows. */
export const PROFILE_MENU_ICON_SIZE = USER_MENU_ICON_SIZE

export const SUPPORT_LINKS = {
  EMAIL: 'mailto:support@hivewatch.zendesk.com',
} as const

/**
 * Mixpanel event names for the profile chain. These strings are a published
 * interface — saved reports and dashboards are built on them — so they are
 * reproduced here byte-for-byte from the `mixpanel.track` calls they replaced.
 * Extend rather than rename.
 */
export const PROFILE_ANALYTICS = {
  profileCard: `${BUTTON_PRESS} Profile Card`,
  openedPopover: 'Opened Profile Popover',
  closedPopover: 'Closed Profile Popover',
  settings: `${BUTTON_PRESS} Settings`,
  logout: `${BUTTON_PRESS} Logout`,
  help: `${BUTTON_PRESS} Help from Profile Menu`,
  sendFeedback: `${BUTTON_PRESS} Send Feedback from Help`,
} as const
